import { render, staticRenderFns } from "./BearView.vue?vue&type=template&id=fcdabc82&"
import script from "./BearView.vue?vue&type=script&lang=js&"
export * from "./BearView.vue?vue&type=script&lang=js&"
import style0 from "./BearView.vue?vue&type=style&index=0&id=fcdabc82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports